
import React, { Fragment } from 'react';
import SummaryItem from '../SummaryItem';

const TribeInfo = props => {
    
    const {
        idx,
        member: {
            americanIndianAlaskaNative : {
                americanIndianAlaskaNativeSelfIdentification,
                memberOfFederallyRecognizedTribeIndicator,
                tribeName,
                state
            },
        },
        tribes
    } = props;

    const tribeStatusInfo = (
        <Fragment>
            <SummaryItem
                textCode = 'common.are_you_ai_an'
                value = { americanIndianAlaskaNativeSelfIdentification }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].americanIndianAlaskaNative.americanIndianAlaskaNativeSelfIdentification`
                        ]
                    ]
                }
            />
            <SummaryItem
                textCode = 'common.are_you_member_federal_tribe'
                value = { memberOfFederallyRecognizedTribeIndicator }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].americanIndianAlaskaNative.memberOfFederallyRecognizedTribeIndicator`
                        ]
                    ]
                }
            />
        </Fragment>
    );
    
    if(!memberOfFederallyRecognizedTribeIndicator) {
        return tribeStatusInfo;
    }



    const getName = (state, tribeName, key) => {
        const result = (state => state ? {
            stateFullNameForSummary: state.name,
            tribeNameForSummary: state.tribes.find(t => t.tribeCode === tribeName).tribeName
        } : {})(tribes.find(tr => tr.code === state));

        return result[key];
    };

    return (
        <Fragment>
            { tribeStatusInfo }
            <div className = 'grid-col-12' >
                <div className = 'grid-row' >
                    <SummaryItem
                        textCode = 'common.membership_info'
                        value = 'common.no_text'
                        summaryItemBorderedClasses
                    />
                </div>
            </div>
            <div className = 'grid-col-11 grid-offset-1 margin-y-0' >
                <div className = 'grid-row margin-left-8 margin-bottom-3' >
                    <SummaryItem
                        textCode = 'common.state'
                        value = { getName(state, tribeName,'stateFullNameForSummary') }
                        ignoreIntl
                        summaryItemMinPaddingClasses
                        desc = {
                            [
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].americanIndianAlaskaNative.state`,
                                        `taxHousehold.householdMember[${ idx }].americanIndianAlaskaNative.tribeName`
                                    ],
                                    getName,
                                    [ 'stateFullNameForSummary' ]
                                ]
                            ]
                        }
                    />

                    <SummaryItem
                        textCode = 'common.tribe_name'
                        value = { getName(state, tribeName, 'tribeNameForSummary') }
                        ignoreIntl
                        summaryItemMinPaddingClasses
                        desc = {
                            [
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].americanIndianAlaskaNative.state`,
                                        `taxHousehold.householdMember[${ idx }].americanIndianAlaskaNative.tribeName`
                                    ],
                                    getName,
                                    [ 'tribeNameForSummary' ]
                                ]
                            ]
                        }
                    />
                </div>
            </div>
        </Fragment>
    );
    
};

export default TribeInfo;